"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultIconUrl = void 0;

var memoize_one_1 = __importDefault(require("@stoplight/memoize-one"));

var react_1 = __importDefault(require("react"));

var baseProps_1 = __importDefault(require("../assets/baseProps"));

var handleEvent_1 = require("../assets/handleEvent");

var isInvalid_1 = require("../channels/isInvalid");

var withResponsive_1 = require("../decorators/withResponsive");

var Input_1 = __importDefault(require("../Input/Input"));

var InputGroup_1 = __importDefault(require("../InputGroup/InputGroup"));

var Select_1 = __importDefault(require("../Select/Select"));

var CountryWrapper_1 = __importDefault(require("./CountryWrapper"));

exports.defaultIconUrl = '//img.imgsmail.ru/mail/ru/images/country_icons/';

var Phone =
/** @class */
function (_super) {
  __extends(Phone, _super);

  function Phone(props) {
    var _this = _super.call(this, props) || this;

    _this.currentOptions = memoize_one_1.default(function (countries, selectedValue) {
      return countries.map(function (country) {
        var icon = _this.getIconUrl(country);

        return __assign({
          shortLabel: icon,
          text: country.name,
          itemJsx: react_1.default.createElement(CountryWrapper_1.default, {
            testId: country.value,
            icon: icon,
            text: country.name,
            arrow: selectedValue === country.value
          })
        }, country);
      });
    });
    var countries = props.countries,
        defaultCountry = props.defaultCountry,
        defaultValue = props.defaultValue,
        value = props.value;
    _this.onCountryChange = _this.onCountryChange.bind(_this);
    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
    _this.valueRenderer = _this.valueRenderer.bind(_this);
    _this.nativeSelectInlineStyles = _this.nativeSelectInlineStyles.bind(_this);
    _this.getStrWithoutPlus = _this.getStrWithoutPlus.bind(_this);
    _this.getIconUrl = _this.getIconUrl.bind(_this);
    _this.validationRegExp = /[\D]+/gi;
    var selectedCountry = null;
    var phone;
    var initValue = defaultValue || value;

    if (initValue) {
      phone = _this.getStrWithoutPlus(initValue).replace(_this.validationRegExp, '');

      var possibleCountries = _this.findCountryByPhone(phone);

      if (possibleCountries.length) {
        selectedCountry = possibleCountries[0];
      }
    }

    selectedCountry = selectedCountry || _this.getCountryByValue(defaultCountry) || countries[0];
    _this.priorityCountry = selectedCountry;
    _this.state = {
      selectedCountry: selectedCountry,
      phone: phone || selectedCountry.code
    };
    return _this;
  }

  Phone.prototype.onCountryChange = function (selectedValue) {
    var _a = this.state,
        selectedCountry = _a.selectedCountry,
        phone = _a.phone;
    var newCountry = this.getCountryByValue(selectedValue);
    var oldCountry = selectedCountry;
    var oldPhoneValue = phone.replace(this.validationRegExp, '');
    var newCountryCode = this.getStrWithoutPlus(newCountry.code);
    var newPhoneValue;

    if (oldPhoneValue) {
      var codeRegExp = new RegExp("^" + this.getStrWithoutPlus(oldCountry.code));
      newPhoneValue = oldPhoneValue.replace(codeRegExp, newCountryCode);
    } else {
      newPhoneValue = newCountryCode;
    }

    this.setState({
      selectedCountry: newCountry,
      phone: newPhoneValue
    });
    var phoneWithPlus = "+" + newPhoneValue;
    handleEvent_1.handleEvent(this.props.onChange, phoneWithPlus);
    handleEvent_1.handleEvent(this.props.onChangeParsed, {
      selectedCountry: newCountry,
      phone: phoneWithPlus
    });
  };

  Phone.prototype.onPhoneChange = function (value) {
    var selectedCountry = this.state.selectedCountry;
    var newPhoneValue = value.slice(1).replace(this.validationRegExp, '');
    var possibleCountries = this.findCountryByPhone(newPhoneValue);
    var newState = {
      phone: newPhoneValue,
      selectedCountry: selectedCountry
    };

    if (possibleCountries.length && possibleCountries.every(function (country) {
      return country.value !== selectedCountry.value;
    })) {
      newState.selectedCountry = possibleCountries[0];
    }

    this.setState(newState);
    var phoneWithPlus = "+" + newPhoneValue;
    handleEvent_1.handleEvent(this.props.onChange, phoneWithPlus);
    handleEvent_1.handleEvent(this.props.onChangeParsed, {
      selectedCountry: newState.selectedCountry,
      phone: phoneWithPlus
    });
  };

  Phone.prototype.findCountryByPhone = function (phone) {
    var _this = this;

    var result = [];
    this.props.countries.forEach(function (country) {
      if (phone.startsWith(_this.getStrWithoutPlus(country.code))) {
        if (_this.priorityCountry && country.value === _this.priorityCountry.value) {
          result.unshift(country);
        } else {
          result.push(country);
        }
      }
    });
    return result;
  };

  Phone.prototype.valueRenderer = function (_a) {
    var shortLabel = _a.shortLabel,
        label = _a.label;
    var text = this.props.withoutText ? undefined : label;
    return react_1.default.createElement(CountryWrapper_1.default, {
      testId: "country-select",
      icon: shortLabel,
      text: text,
      selected: true
    });
  };

  Phone.prototype.nativeSelectInlineStyles = function () {
    return {
      backgroundImage: "url('" + this.getIconUrl(this.state.selectedCountry) + "')",
      color: 'transparent',
      padding: '0 0 0 50px',
      overflow: 'hidden',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '35% 50%',
      backgroundSize: '16px 11px',
      boxSizing: 'border-box',
      width: 50
    };
  };

  Phone.prototype.getCountryByValue = function (value) {
    return value && this.props.countries.find(function (country) {
      return country.value === value;
    }) || this.priorityCountry;
  };

  Phone.prototype.getStrWithoutPlus = function (value) {
    return value.startsWith('+') ? value.slice(1) : value;
  };

  Phone.prototype.getIconUrl = function (_a) {
    var icon = _a.icon,
        value = _a.value;
    return icon || exports.defaultIconUrl + value + ".png";
  };

  Phone.prototype.render = function () {
    var _a = this,
        props = _a.props,
        state = _a.state;

    var value = props.value,
        disabled = props.disabled,
        required = props.required,
        autoFocus = props.autoFocus,
        autoCapitalize = props.autoCapitalize,
        autoComplete = props.autoComplete,
        autoCorrect = props.autoCorrect,
        spellCheck = props.spellCheck,
        name = props.name,
        onInput = props.onInput,
        onBlur = props.onBlur,
        onFocus = props.onFocus,
        selectAutoFocus = props.selectAutoFocus,
        selectOpenOnFocus = props.selectOpenOnFocus,
        selectMenuMaxHeight = props.selectMenuMaxHeight,
        countries = props.countries,
        selectMenuMaxWidth = props.selectMenuMaxWidth,
        selectMenuMinWidth = props.selectMenuMinWidth,
        testId = props.testId,
        id = props.id,
        responsive = props.responsive,
        invalid = props.invalid;
    var selectedCountry = state.selectedCountry,
        phone = state.phone;
    return react_1.default.createElement(InputGroup_1.default, __assign({}, baseProps_1.default(props), {
      testId: testId
    }), react_1.default.createElement(Select_1.default, {
      inline: true,
      testId: testId && testId + "__select",
      id: id && id + "__select",
      name: "Country",
      autoFocus: selectAutoFocus,
      openOnFocus: selectOpenOnFocus,
      value: selectedCountry.value,
      valueRenderer: this.valueRenderer,
      nativeSelectInlineStyles: this.nativeSelectInlineStyles,
      onChange: this.onCountryChange,
      options: this.currentOptions(countries, selectedCountry.value),
      disabled: disabled,
      menuMaxHeight: selectMenuMaxHeight,
      menuMaxWidth: selectMenuMaxWidth,
      menuMinWidth: selectMenuMinWidth,
      responsive: responsive,
      invalid: invalid
    }), react_1.default.createElement(Input_1.default, {
      type: "tel",
      testId: "phone-input",
      id: id && id + "__phone-input",
      value: "+" + this.getStrWithoutPlus(value || phone),
      onChange: this.onPhoneChange,
      disabled: disabled,
      required: required,
      autoFocus: autoFocus,
      autoCapitalize: autoCapitalize,
      autoComplete: autoComplete,
      autoCorrect: autoCorrect,
      spellCheck: spellCheck,
      name: name,
      onInput: onInput,
      onBlur: onBlur,
      onFocus: onFocus,
      responsive: responsive,
      invalid: invalid
    }));
  };

  Phone = __decorate([isInvalid_1.withIsInvalid(isInvalid_1.mapIsInvalidToProps), withResponsive_1.withResponsive], Phone);
  return Phone;
}(react_1.default.Component);

exports.default = Phone;